import { useState } from "react";
import { Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/dashboard";
import ChallengeReportContextWrapper from "./container/ChallengeReportContext";
import ChallengeReportDetails from "./components/ChallengeReportDetails";
import ChallengeOverView from "./components/ChallengeOverview";
import ChallengeMembers from "./components/ChallengeMembers";
import ChallengeAssessmentReports from "./components/ChallengeAssessmentReports";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";

const TABS = [
  { title: "Challenge Details", value: "overview", component: ChallengeOverView },
  { title: "Challenge Members", value: "members", component: ChallengeMembers },
  { title: "Assessment Reports", value: "assessment_reports", component: ChallengeAssessmentReports },
];

const ChallengeReport = () => {
  const { t } = useLocalizedTranslation();
  const [activeTab, setActiveTab] = useState(TABS[0].value);

  const ActiveComponent = TABS.find((tab) => tab.value === activeTab)?.component || null;

  return (
    <DashboardLayout>
      <ChallengeReportContextWrapper>
        <div className="mt-header mb-5 container-big">
          <ChallengeReportDetails t={t} />

          <div className="mb-8 mx-8 mt-3">
            <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)}>
              {TABS.map((tab) => (
                <Tab key={tab.value} label={t(tab.title)} value={tab.value} />
              ))}
            </Tabs>

            <div className="mt-3">
              {ActiveComponent && <ActiveComponent t={t} />}
            </div>
          </div>
        </div>
      </ChallengeReportContextWrapper>
    </DashboardLayout>
  );
};

export default ChallengeReport;
